<template>
  <div>
    <pdf-block :src="url" :page="pageNum" @num-pages="pageTotalNum=$event"></pdf-block>
    <button @click="prePage">上一页</button>
    <button @click="nextPage">下一页</button>
    <span>{{ pageNum }} / {{ pageTotalNum }}</span>
  </div>
</template>

<script>
import pdfBlock from 'vue-pdf'

export default {
    components: { pdfBlock },
  data() {
    return {
      url: '',
      pageNum: 1,
      pageTotalNum: 0
    }
  },
  mounted() {
    this.url = this.$route.query.fileUrl
  },
  methods: {
    prePage() {
      this.pageNum = this.pageNum > 1 ? this.pageNum - 1 : this.pageTotalNum
    },
    nextPage() {
      this.pageNum = this.pageNum < this.pageTotalNum ? this.pageNum + 1 : 1
    }
  }
}
</script>